import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaintenanceWatcherService } from './authentication/service/maintenance-watcher.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly maintenanceWatcher = inject(MaintenanceWatcherService);

  ngOnInit(): void {
    this.maintenanceWatcher.start();
  }

  ngOnDestroy(): void {
    this.maintenanceWatcher.stop();
  }
}
